export enum AssetsTabs {
  PlatformBalance = 'platform',
  TradersBalance = 'traders',
  MerchantsBalance = 'merchants',
  P2PProvidersBalance = 'p2p-providers',
}
